import React, { useState, useRef, useEffect } from "react";
import {
  Popper,
  Box,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangeCalendar } from "@mui/x-date-pickers-pro/DateRangeCalendar";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import resetGif from "../Assets/images/resticon.gif";
import calender from "../Assets/images/calendar.gif";
import { Tooltip } from "@mui/material";
const CustomDateRangeCalendar = ({ value, onChange }) => {
  LicenseInfo.setLicenseKey(
    "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
  );
  const [open, setOpen] = useState(false);
  const [tempValue, setTempValue] = useState(value || [null, null]);
  const anchorRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  //   useEffect(() => {
  //     if (value?.[0] && value?.[1]) {
  //       console.log(
  //         `Start Date: ${dayjs(value[0]).format("YYYY-MM-DD")}, End Date: ${dayjs(
  //           value[1]
  //         ).format("YYYY-MM-DD")}`
  //       );
  //     }
  //   }, [value]);

  const handleApply = () => {
    onChange(tempValue);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const handleClear = () => {
    setTempValue([null, null]);
    onChange([null, null]);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" alignItems="center" gap={2}>
        {/* <Typography variant="body2">
          {value?.[0]
            ? `${dayjs(value[0]).format("DD/MM/YYYY")} - ${dayjs(
                value[1]
              ).format("DD/MM/YYYY")}`
            : "Select Date Range"}
        </Typography> */}

        <Box
          component="img"
          src={calender}
          alt="calender"
          sx={{
            width: 28,
            height: 28,
            cursor: "pointer",
            ml: 1,
          }}
          ref={anchorRef}
          onClick={() => {
            setOpen((prev) => !prev);
          }}
        />
        {/* ✅ Reset GIF */}
        <Tooltip title="Reset Date Range" arrow>
          <Box
            onClick={() => {
              setTempValue([null, null]);
              onChange([null, null]);
              setOpen(false);
            }}
            sx={{
              cursor: "pointer",
              ml: 1,
              fontSize: "20px",
              userSelect: "none",
              transition: "transform 0.2s ease-in-out",
              "&:active": {
                transform: "scale(1.2)",
              },
            }}
          >
            🔄
          </Box>
        </Tooltip>

        {isMobile ? (
          <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
            <DialogContent>
              <DateRangeCalendar
                value={tempValue}
                onChange={(newRange) => setTempValue(newRange)}
              />
            </DialogContent>
            <DialogActions>
              <Button color="error" onClick={handleCancel}>
                Cancel
              </Button>

              <Button onClick={handleClear}>clear</Button>
              <Button onClick={handleApply} variant="contained">
                Apply
              </Button>
            </DialogActions>
          </Dialog>
        ) : (
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            sx={{ zIndex: 1500 }} // High z-index to be on top
          >
            <Box
              sx={{
                bgcolor: "background.paper",
                border: 1,
                p: 2,
                boxShadow: 6,
              }}
            >
              <DateRangeCalendar
                value={tempValue}
                onChange={(newRange) => setTempValue(newRange)}
              />
              <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                <Button size="small" onClick={handleCancel} color="error">
                  cancel
                </Button>
                <Button size="small" onClick={handleClear}>
                  clear
                </Button>
                <Button size="small" variant="contained" onClick={handleApply}>
                  Apply
                </Button>
              </Box>
            </Box>
          </Popper>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default CustomDateRangeCalendar;
